import PropTypes from 'prop-types';
import * as React from 'react';
import {Form} from 'react-bootstrap';

import styles from './FilterNodeTypeTextInput.less';

class FilterNodeTypeTextInput extends React.PureComponent {
  render() {
    const {handleChange, inputRef, isOpened, value} = this.props;

    return (
      <Form.Control
        ref={inputRef}
        as={'input'}
        tabIndex={isOpened ? 0 : -1}
        type={'text'}
        size={'sm'}
        className={styles.dlFilterNodeTypeTextInput}
        value={value}
        onChange={handleChange}
      />
    );
  }
}

FilterNodeTypeTextInput.displayName = 'FilterNodeTypeTextInput';

FilterNodeTypeTextInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
  isOpened: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.string,
  ]).isRequired,
  handleChange: PropTypes.func.isRequired,
};

FilterNodeTypeTextInput.defaultProps = {
  isOpened: false,
};

export default FilterNodeTypeTextInput;
